import { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { TextField } from '@habitech/keychain-atoms-inputs';
import { Button } from '@habitech/call-to-action';
import Modal from 'src/components/common/modal/Modal';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/RootState';
import { Form, WrapperButton, TextModal } from '../Frauds.styles';
import { postFraudUsers } from 'src/apis/fraudUsers';
import { typeForm } from '../Frauds.constans'

const initStateModal = {
    show: false,
    text: '',
    success: false,
};

const FraudsForm = ({ getFraudUsersList }: { getFraudUsersList: Function }) => {
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(initStateModal);
    const token = useSelector((state: RootState) => state.User.token);
    const [typeAction, setTypeAction] = useState('');

    const validationSchema = yup.object({
        email: yup
            .string()
            .required('Debe ingresar un correo de usuario')
            .email('Ingrese un correo valido'),
    });
    const initialValues = {
        email: '',
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchema,
        onSubmit: (values: any, formikHelpers) => {
            setLoading(true);
            const data = {
                country: 'MX',
                email: values.email,
                action: typeAction,
            };
            postFraudUsers(data, token).then((res) => {
                setModal({
                    show: true,
                    text: res.message,
                    success: true,
                });
                setLoading(false);
                getFraudUsersList();
                formikHelpers.resetForm();
            }).catch((e) => {
                console.error(e);
                setModal({
                    show: true,
                    text: 'Hubo un error en el servidor',
                    success: false,
                });
                setLoading(false);
            });
        },
    });

    const handleSubmitType = (type: string) => {
        setTypeAction(type);
        formik.handleSubmit();
    };
    const handleClose = () => {
        setModal(initStateModal);
    };

    return (
        <>
            <Form data-id="frauds-form">
                <TextField
                    dataId="frauds-email"
                    name="email"
                    label="Correo de usuario sospechoso"
                    originType="pcom"
                    placeHolder="Ingrese el correo del usuario"
                    innerLabel
                    value={formik.values.email}
                    onChange={(_, _value) =>
                        formik.setFieldValue('email', _value, false)
                    }
                    error={Boolean(formik.errors.email)}
                    errorMessage={`${formik.errors.email}`}
                />
                <div className="wrapper-buttons">
                    <Button
                        dataId="btn-send"
                        originType="pcom"
                        size="large"
                        onClick={() => handleSubmitType(typeForm.activate)}
                        loading={loading}
                        disabled={loading && typeAction !== typeForm.activate}
                    >
                        Ingresar correo
                    </Button>
                    <Button
                        dataId="btn-edit"
                        originType="pcom"
                        size="large"
                        variant="stroke"
                        onClick={() => handleSubmitType(typeForm.verify)}
                        loading={loading}
                        disabled={loading && typeAction !== typeForm.verify}
                    >
                        Validar correo
                    </Button>
                </div>
            </Form>
            {modal.show && (
                <Modal onClose={handleClose}>
                    <div
                        style={{ margin: '38px 0 16px' }}
                        data-id="confirmation-message"
                    >
                        <TextModal>{modal.text}</TextModal>
                        <WrapperButton>
                            <Button
                                dataId="button-search"
                                originType="pcom"
                                size="large"
                                onClick={handleClose}
                            >
                                Aceptar
                            </Button>
                        </WrapperButton>
                    </div>
                </Modal>
            )}
        </>
    );
};

export default FraudsForm;
